


































































export default {
  props: {
    visibleButtons: {
      type: Number,
      required: false,
      default: 3,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    alignLeft: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    startPage() {
      // When on the first page
      if (this.currentPage === 1) {
        return 1;
      }

      // When on the last page
      if (this.isOnLastPage) {
        return this.totalPages - this.visibleButtons + 1;
      }

      // When in between
      return this.currentPage - 1;
    },
    showFirst() {
      if (this.totalPages < this.visibleButtons) {
        return false;
      }
      return this.currentPage >= this.visibleButtons;
    },
    showlast() {
      if (this.totalPages < this.visibleButtons) {
        return false;
      }
      return this.currentPage <= this.totalPages - this.visibleButtons + 1;
    },
    pages() {
      const range = [];
      if (this.totalPages < this.visibleButtons) {
        for (let i = this.startPage; i <= this.totalPages; i += 1) {
          range.push({
            number: i,
            isDisabled: i === this.currentPage,
          });
        }
      } else {
        for (
          let i = this.startPage;
          i < this.startPage + this.visibleButtons;
          i += 1
        ) {
          range.push({
            number: i,
            isDisabled: i === this.currentPage,
          });
        }
      }

      return range;
    },
    isOnFirstPage() {
      return this.currentPage === 1;
    },
    isOnLastPage() {
      return this.currentPage === this.totalPages;
    },
  },
  methods: {
    onClickFirstPage() {
      this.$emit('onPageChanged', 1);
    },
    onClickPreviousPage() {
      this.$emit('onPageChanged', this.currentPage - 1);
    },
    onClickPage(page) {
      this.$emit('onPageChanged', page);
    },
    onClickNextPage() {
      this.$emit('onPageChanged', this.currentPage + 1);
    },
    onClickLastPage() {
      this.$emit('onPageChanged', this.totalPages);
    },
    isPageActive(page) {
      return this.currentPage === page.number;
    },
  },
};
